<template>
  <div class="container">
    <header-app
      :title="$t('Feedback')"
      class="header-brand"
      to="menu"
    ></header-app>
    <wrap>
      <div class="center text-center">
        <img
          src="@/assets/feedback.jpg"
          alt
          class="item-image rounded-circle center img-feedback"
        />
        <form>
          <div class="form-group feedback-input">
            <label class="center">
              <br />
              <h4>{{ hotel.title }}</h4>
            </label>
            <rate :length="5" v-model="rate" />
            <br />
            <textarea
              class="form-control"
              v-model="comment"
              rows="3"
            ></textarea>
          </div>
          <br />
          <br />
          <div class="center">
            <btn-loading
              @click.native="submitRate()"
              class="btn-brand shadow-sm btn-lg"
              icon="message-circle"
              :title="$t('Submit')"
              :loading="loading"
            />
          </div>
        </form>
      </div>
    </wrap>
  </div>
</template>
<script>
import store from "@/store";

export default {
  middleware: ["auth", "feedback"],
  name: "FeedBack",
  data: () => ({
    rate: 0,
    comment: "",
  }),
  metaInfo: {
    title: "DiscoverLao Ordering",
  },
  computed: {
    hotel() {
      return store.getters["location_selected/placeSelected"] || {};
    },
    hotelType() {
      return store.getters["location_selected/placeType"];
    },
    sale_id() {
      return store.getters["order/sale_id"];
    },
    loading() {
      return store.getters["rate/loading"];
    },
  },
  methods: {
    openMenu() {
      this.$router.push({ name: "menu" });
    },
    async submitRate() {
      let data = {
        type_id: this.hotel.id,
        type: this.hotelType,
        sale_id: this.sale_id,
        star: this.rate,
        comment: this.comment,
      };
      await store.dispatch("rate/submitRate", data);
      await store.dispatch("order/clearSaleId");
      this.$router.push({ name: "orders" });
    },
  },
};
</script>
<style lang="scss">
.img-feedback {
  max-width: 150px;
  border-radius: 100%;
}
.feedback-input {
  margin-left: 10px;
  margin-right: 10px;
}
</style>